export default "__VITE_ASSET__Cl8bA4Gq__";